module.exports = __webpack_public_path__ + "img/live07.1ef24d52.png";